import { ArrowBackIcon } from "@chakra-ui/icons";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

export default function CustomDataModal({
  isOpen,
  children,
  header,
  onClose,
  size,
}) {
  return (
    <Modal
      scrollBehavior="inside"
      isCentered
      size={size ? size : "4xl"}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent
        maxH={"90vh"}
        mx={{ base: "10px", md: "auto" }}
        maxW={{ base: "calc(100vw - 20px)", md: size === "7xl" ? "80rem" : "56rem" }}
        borderRadius={{ base: "8px", md: "md" }}
      >
        <ModalHeader color="white" bg="#2B2B2B" fontSize={{ base: "14px", md: "lg" }} py={{ base: 2, md: 3 }} pr="50px" position="sticky" top="0" zIndex="1">
          {header}
        </ModalHeader>
        <ModalCloseButton onClick={onClose} />
        <ModalBody color="#000" px={{ base: 2, md: 6 }} py={{ base: 2, md: 4 }}>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
}
